import { Capacitor } from "@capacitor/core";
import axios from "axios";
import { installAxiosInterceptors } from "../config/axios";
import { isTauri } from "../native/isTauri";
import type { Platform } from "./Platform";
import { createIosPlatform } from "./ios/createIosPlatform";
import { platformRef } from "./platformRef";
import { createWebPlatform } from "./web/createWebPlatform";

export async function createPlatform(): Promise<Platform> {
    if (isTauri()) {
        throw new Error("The desktop host must install its Tauri platform adapter");
    }
    return Capacitor.isNativePlatform() ? createIosPlatform() : createWebPlatform();
}

export function installPlatform(platform: Platform): void {
    platformRef.current = platform;
    axios.defaults.baseURL = platform.bootstrap.apiOrigin;
    installAxiosInterceptors();
}
